import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/animations.css';

/**
 * Mount the React application into #root.
 * StrictMode enables additional runtime warnings in development.
 */
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
